import { FormattedMessage } from 'react-intl'
import Head from 'components/Head'
import Weather from 'clients/weather'
import { Content, Header, Main } from 'components/page'
import { Page } from 'layouts/pages'
import { Metadata, Station, Footer } from 'components/weather/station'
import { Error, Loading } from 'components/text'
import * as WeatherClient from 'clients/weather'
import * as Async from 'contexts/async'
import * as Generic from '@avcan/prismic/clients/generic'
import { GenericContent } from 'prismic/layouts'
import * as NextUtils from 'utils/next'

export async function getStaticProps({ params, locale }) {
    const [station, disclaimer] = await Promise.all([
        Weather.station(params.id),
        Generic.get('weather-station-disclaimer', locale),
    ])

    return {
        props: {
            station,
            disclaimer,
        },
    }
}

export async function getStaticPaths() {
    const stations = await Weather.stations()
    const paths = stations.map(station => ({
        params: {
            id: station.stationId.toString(),
        },
    }))

    return {
        paths: NextUtils.internationalizeStaticPaths(paths),
        fallback: false,
    }
}

export default function WeatherStationDetails({ station, disclaimer }) {
    const { stationId: id, name } = station

    return (
        <Page>
            <Head title={name} description={name} />
            <Header title={name} />
            <Content>
                <Main>
                    <Metadata {...station} id={id} />
                    <Async.Provider value={WeatherClient.useMeasurements(id)}>
                        <Async.Pending>
                            <Loading>
                                <FormattedMessage
                                    description="Layout weather/station/WeatherStation"
                                    defaultMessage="Loading measurements..."
                                />
                            </Loading>
                        </Async.Pending>
                        <Async.Found>
                            {measurements => <Station measurements={measurements} />}
                        </Async.Found>
                        <Async.Error>
                            <Error />
                        </Async.Error>
                    </Async.Provider>
                    <Footer>
                        <GenericContent payload={disclaimer} />
                    </Footer>
                </Main>
            </Content>
        </Page>
    )
}
